import * as React from 'react';
import { Fragment } from 'react';
import Pagination from '../components/Pagination';
import { BulkActionProps, BulkDeleteButton, DateInput, List, ListProps } from 'react-admin';
import { OrganizationNotificationList } from './OrganizationNotificationList';
import { OrganizationNotificationDatagrid } from './OrganizationNotificationDatagrid';
import { Theme, useMediaQuery } from '@material-ui/core';
import { ExportField, generateExporter } from '../util/Exporter';
import { OrganizationNotification } from './OrganizationNotification';

export * from './OrganizationNotification';
export * from './OrganizationNotificationCreate';
export * from './OrganizationNotificationDatagrid';
export * from './OrganizationNotificationEdit';
export * from './OrganizationNotificationList';
export * from './OrganizationNotificationShow';

const OrganizationNotificationsBulkActionButtons = (props: BulkActionProps) => (
	<Fragment>
		<BulkDeleteButton {...props} undoable={false}/>
	</Fragment>
);

export const exportFields: ExportField[] = [
	{ key: 'id', header: 'ID' },
	{ key: 'title', header: 'Title' },
	{ key: 'body', header: 'Body' },
	{ key: 'dayInMonth', header: 'Day in month' }
];

export const OrganizationNotificationsData = (props: ListProps): React.ReactElement => {
	const isXSmall = useMediaQuery<Theme>(theme => theme.breakpoints.down('xs'));
	const exportDataMapper = (entity: OrganizationNotification) => entity;

	const organizationNotificationsFilter = [
		<DateInput source="from__createdAt" label="FROM_CREATED_AT"
		           alwaysOn/>,
		<DateInput source="to__createdAt" label="TO_CREATED_AT"
		           alwaysOn/>
	];

	return (
		<Fragment>
			<List
				exporter={generateExporter('התראות ארגוניות', exportFields, exportDataMapper)}
				{...props}
				filters={organizationNotificationsFilter}
				bulkActionButtons={<OrganizationNotificationsBulkActionButtons/>}
				title="ORGANIZATION_NOTIFICATIONS"
				sort={{ field: 'dayInMonth', order: 'ASC' }}
				perPage={20}
				pagination={<Pagination/>}
			>
				{isXSmall ? <OrganizationNotificationList/> : <OrganizationNotificationDatagrid/>}
			</List>
		</Fragment>
	);
};
